<template>
  <div class="qikan-container">
    <h2>期刊论文</h2>
    <div v-if="list.length">
      <div class="qikan-list">
        <template v-for="(item, index) in list">
          <list-item class="qikan-item" :key="index" :info="item"></list-item>
        </template>
      </div>
      <!-- 分页 -->
      <pagination v-show="total>0" :total="total" :page.sync="pageParams.pageNumber" :pageSizes="[6, 10, 20, 30]" :limit.sync="pageParams.pageSize" @pagination="getPageData" />
    </div>
    <div class="none-result" v-else>
      暂无期刊论文信息
    </div>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";
import ListItem from "./components/listItem";

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryBean: {
        contentBean: {
          type1: "期刊论文",
        },
      },
      pageParams: {
        pageNumber: 1,
        pageSize: 6,
        sort: "priority, publish_time",
        order: "desc"
      },
    }
  },
  props: {

  },
  components: {
    ListItem
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getData(params) {
      let data = Object.assign({}, this.pageParams, this.queryBean, params || {});
      return new Promise(async (resolve, reject) => {
        const res = await contentFinds(data);
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    },
    getPageData() {
      this.getData().then(res => {
        this.list = res.list;
        this.total = res.total;
      })
    }
  },
}
</script>

<style lang="less" scoped>
.qikan-container {
  width: 100%;
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }

  .qikan-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 30px;
    .qikan-item {
      width: calc((100% - 60px) / 3);
    }
  }

  .none-result {
    text-align: center;
    font-size: 16px;
    color: #999;
    line-height: 60px;
    margin: 30px;
  }
}

@media screen and (max-width: 768px) {
  .qikan-container {
    .qikan-list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 14px;
      .qikan-item {
        width: 100%;
      }
    }
  }
}
</style>